import { Theme } from '@mui/material';
import styled, { css } from 'styled-components';

import {
  TMenuOrigins,
  TStyledMenuPaperProps,
} from '@/shared/components/ui/paper/menu-paper/menu-paper.types';
import { Paper } from '@/shared/components/ui/paper/paper.styled';
import {
  DEFAULT_ANCHOR_ORIGIN,
  DEFAULT_TRANSFORM_ORIGIN,
} from '@/shared/components/ui/popover/components/popover/popover.const';

export const getBorderRadiusAndMargin = (theme: Theme) => {
  return ({
    anchorOrigin = DEFAULT_ANCHOR_ORIGIN,
    transformOrigin = DEFAULT_TRANSFORM_ORIGIN,
  }: TMenuOrigins) => {
    const isAnchor = (vertical: string, horizontal: string) =>
      transformOrigin.vertical === vertical &&
      transformOrigin.horizontal === horizontal;

    const borderRadius = (vertical: string, horizontal: string) =>
      isAnchor(vertical, horizontal)
        ? theme.shape.menuAnchorRadius
        : theme.shape.menuRadius;

    const margin = () => {
      if (anchorOrigin.vertical !== transformOrigin.vertical) {
        return css`
          margin-top: ${transformOrigin.vertical === 'bottom'
            ? '-0.5rem'
            : '0.5rem'};
        `;
      }
      if (anchorOrigin.horizontal !== transformOrigin.horizontal) {
        return css`
          margin-left: ${transformOrigin.horizontal === 'right'
            ? '-0.5rem'
            : '0.5rem'};
        `;
      }
      return null;
    };

    return css`
      border-radius: ${borderRadius('top', 'left')}
        ${borderRadius('top', 'right')} ${borderRadius('bottom', 'right')}
        ${borderRadius('bottom', 'left')};

      ${margin()}
    `;
  };
};

export const StyledMenuPaper = styled(Paper)<TStyledMenuPaperProps>`
  && {
    padding: 1rem;
    display: flex;
    gap: 2px;
    flex-direction: column;
    box-shadow: ${({ theme }) => theme.shadow.menu};
    width: fit-content;
    border: 1px solid ${({ theme }) => theme.palette.stroke.primary};

    ${({ theme, $anchorOrigin, $transformOrigin }) =>
      getBorderRadiusAndMargin(theme as Theme)({
        anchorOrigin: $anchorOrigin,
        transformOrigin: $transformOrigin,
      })};

    hr {
      margin: 0.5rem;
    }

    ul {
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
  }
`;
